<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `/details/responsible/${inputs.id}`
            : '/details/responsible'
        "
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Campo de Análisis</label>
              <!-- <app-input
                type="text"
                v-model="inputs.field"
                placeholder="Ingrese el campo de análisis"
                :required="true"
              /> -->
              <app-input
                type="select"
                v-model="inputs.field"
                :list="fieldList"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre y Apellido</label>
              <app-input
                type="text"
                v-model="inputs.name"
                placeholder="Ingrese el nombre y apellido"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Calificación</label>
              <app-input
                type="select"
                v-model="inputs.qualification"
                :list="qualificationList"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    type: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      disabledSubmit: false,
      qualificationList: [
        { id: null, value: "Seleccione" },
        { id: "Autorizado", value: "Autorizado" },
        { id: "No Autorizado", value: "No Autorizado" },
      ],
      scopes: [],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
    fieldList() {
      let tmp = [{ id: "", value: "Seleccione" }];
      if (this.scopes.level4) {
        tmp = [
          ...tmp,
          ...this.scopes.level4.map((item) => {
            return { id: item.value, value: item.value };
          }),
        ];
      }
      return tmp;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
    this.getData();
  },
  methods: {
    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.inputs.type = this.type;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
    getData() {
      this.preloader = true;

      this.axiosGet(
        `request/options?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const {
              data: { scopes },
            } = response;
            this.scopes = scopes;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
